import {
  normalizeValue,
  resolveCaseStatusValue,
  resolveMediaRecordStatusValue,
  resolveScanStatusValue
} from './statusNormalization';

export function isUploadAllowedCaseStatus(value) {
  const normalized = resolveCaseStatusValue(value);
  return normalized !== 'archived'
    && normalized !== 'archiving'
    && normalized !== 'retrieving';
}

export function isPlaybackAllowedRecordStatus(value) {
  const normalized = resolveMediaRecordStatusValue(value);
  return normalized === 'submitted' || normalized === 'retrieved';
}

export function isVirusStatus(value) {
  const normalized = resolveScanStatusValue(value);

  if (!normalized) {
    return false;
  }

  const normalizedCompact = normalized.replace(/[\s_\-]/g, '');
  const cleanContainsMarkers = [
    'novirus',
    'nothreat',
    'noinfection',
    'notinfected',
    'threatnotfound',
    'malwarenotfound',
    'virusnotfound'
  ];
  const cleanExactMarkers = new Set(['clean', 'safe', 'benign', 'pass', 'passed']);

  if (cleanContainsMarkers.some((marker) => normalizedCompact.includes(marker)) || cleanExactMarkers.has(normalizedCompact)) {
    return false;
  }

  return normalized === 'quarantined'
    || normalized === 'quarantine'
    || normalized === 'blocked'
    || normalized === 'rejected'
    || normalizedCompact === 'virus'
    || normalizedCompact.includes('virusdetected')
    || normalizedCompact.includes('virusfound')
    || normalizedCompact.includes('malware')
    || normalizedCompact.includes('malicious')
    || normalizedCompact.includes('quarantine')
    || normalizedCompact.includes('infect')
    || normalizedCompact.includes('threatdetected')
    || normalizedCompact.includes('threatfound')
    || normalizedCompact.includes('unsafe');
}

export function isSuccessfulStatus(value) {
  const normalized = resolveScanStatusValue(value);

  return normalized === 'clean'
    || normalized === 'completed'
    || normalized === 'complete'
    || normalized === 'success'
    || normalized === 'succeeded'
    || normalized === 'submitted'
    || normalized.includes('clean')
    || normalized.includes('pass')
    || normalized.includes('safe')
    || normalized.includes('benign')
    || normalized.includes('no virus')
    || normalized.includes('novirus')
    || normalized.includes('no-virus')
    || normalized.includes('no_virus')
    || normalized.includes('no threat')
    || normalized.includes('nothreat')
    || normalized.includes('no-threat')
    || normalized.includes('no_threat')
    || normalized.includes('threatnotfound')
    || normalized.includes('noinfection')
    || normalized.includes('notinfected');
}

export function isSuccessfulLifecycleStatus(value) {
  const raw = normalizeValue(value);
  const mediaRecordStatus = resolveMediaRecordStatusValue(value);
  return raw === 'approved'
    || raw === 'accepted'
    || raw === 'available'
    || mediaRecordStatus === 'submitted'
    || mediaRecordStatus === 'retrieved';
}

export function isFailedStatus(value) {
  const normalized = resolveScanStatusValue(value);
  return normalized.includes('fail') || normalized.includes('error');
}

export function isTerminalScanStatus(value) {
  const normalized = resolveScanStatusValue(value);
  return isSuccessfulStatus(normalized)
    || normalized === 'quarantined'
    || normalized === 'failed'
    || isVirusStatus(normalized)
    || isFailedStatus(normalized);
}
